import { render, staticRenderFns } from "./notes.vue?vue&type=template&id=7fe48386&scoped=true&"
import script from "./notes.vue?vue&type=script&lang=js&"
export * from "./notes.vue?vue&type=script&lang=js&"
import style0 from "./notes.vue?vue&type=style&index=0&id=7fe48386&prod&scoped=true&lang=css&"
import style1 from "./notes.vue?vue&type=style&index=1&id=7fe48386&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe48386",
  null
  
)

export default component.exports